

const InFramesUser = () => {
    
    return (
        <svg className={"svg-icon"} width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M10.0548 11.428C12.0273 11.428 13.6263 9.82903 13.6263 7.85659C13.6263 5.88414 12.0273 4.28516 10.0548 4.28516C8.08238 4.28516 6.4834 5.88414 6.4834 7.85659C6.4834 9.82903 8.08238 11.428 10.0548 11.428Z"
                stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path
                d="M14.7833 15.3566C13.478 14.2037 11.7964 13.5674 10.0547 13.5674C8.31313 13.5674 6.63152 14.2037 5.32617 15.3566"
                stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path
                d="M19.3404 15V17.8571C19.3404 18.236 19.1899 18.5994 18.922 18.8673C18.6541 19.1352 18.2907 19.2857 17.9118 19.2857H15.0547"
                stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path
                d="M15.0547 0.713867H17.9118C18.2907 0.713867 18.6541 0.864377 18.922 1.13229C19.1899 1.4002 19.3404 1.76356 19.3404 2.14244V4.99958"
                stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path
                d="M0.769043 4.99958V2.14244C0.769043 1.76356 0.919553 1.4002 1.18746 1.13229C1.45537 0.864377 1.81873 0.713867 2.19761 0.713867H5.05476"
                stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path
                d="M5.05476 19.2857H2.19761C1.81873 19.2857 1.45537 19.1352 1.18746 18.8673C0.919553 18.5994 0.769043 18.236 0.769043 17.8571V15"
                stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

export default InFramesUser